import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/kit";

export function TutorialInvite() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [hidden, setHidden] = useState(false);
  if (!user || user.tutorial_seen || hidden || user.role === "superadmin") return null;
  const close = (go) => {
    setHidden(true);
    setUser({ ...user, tutorial_seen: true });
    api("/auth/tutorial-seen", { method: "POST" }).catch(() => {});
    if (go) nav("/tutorial");
  };
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.55)" }} data-testid="tutorial-invite">
      <div className="w-full max-w-md rounded-3xl overflow-hidden fade-in shadow-2xl" style={{ background: "var(--surface)" }}>
        <img src="/tutorial/il-start.webp" alt="" className="w-full h-44 object-cover" />
        <div className="p-6 flex flex-col gap-3">
          <div className="flex items-center gap-2 h3"><GraduationCap size={20} style={{ color: "var(--brand)" }} /> Bem-vindo, {user.name?.split(" ")[0]}!</div>
          <p className="text-sm">Quer aprender a usar o sistema em poucos minutos? O tutorial mostra, passo a passo e com as telas reais, tudo o que você vai usar no dia a dia.</p>
          <p className="caption">Ele fica sempre disponível em Menu → Tutorial.</p>
          <div className="flex flex-wrap gap-2 mt-2">
            <Button onClick={() => close(true)} data-testid="tutorial-invite-start">Ver tutorial</Button>
            <Button variant="ghost" onClick={() => close(false)} data-testid="tutorial-invite-dismiss">Agora não</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
